var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBuildingSize = function SvgBuildingSize(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 2H4.25C3.15 2 2.25 2.9 2.25 4V20C2.25 20.5304 2.46071 21.0391 2.83579 21.4142C3.21086 21.7893 3.71957 22 4.25 22H20.25C21.36 22 22.25 21.11 22.25 20V4C22.25 3.46957 22.0393 2.96086 21.6642 2.58579C21.2891 2.21071 20.7804 2 20.25 2ZM4.25 6L6.25 4H11.15L4.25 10.9V6ZM4.25 13.7L13.95 4H18.85L4.25 18.6V13.7ZM20.25 18L18.25 20H13.35L20.25 13.1V18ZM20.25 10.3L10.55 20H5.65L20.25 5.4V10.3Z",
    fill: "#94A3B8"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBuildingSize, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/buildingSize.1a0f9e00.svg";
export { ForwardRef as ReactComponent };